import Footer from '@/renderer/Footer';
import Header from '@/renderer/Header';
import { usePageContext } from '@/renderer/utils/usePageContext';

export default TermsPage;

export function Terms() {
  const {
    config: { title },
  } = usePageContext();

  return (
    <div className="flex h-40 min-h-[stretch] flex-1 grow flex-col justify-between overflow-hidden">
      <Header title="Terms & Conditions" className="py-2 md:hidden" />
      <div className="overflow-auto">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto max-w-2xl py-4 pt-0 text-center sm:pb-24 sm:pt-20">
            <h1 className="hidden text-3xl font-bold tracking-tight text-zinc-900 dark:text-zinc-200 sm:block sm:text-4xl">
              {title}
            </h1>
            <p className="mt-4 text-left text-xs leading-7 text-zinc-600 dark:text-zinc-400 sm:text-center sm:text-base">
              Last updated on August 28, 2023
            </p>
          </div>
        </div>
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="prose prose-sm prose-zinc max-w-prose dark:prose-invert prose-a:font-semibold prose-a:text-emerald-500 prose-a:hover:text-emerald-600 sm:mx-auto">
            <p>
              These terms and conditions outlines the rules and regulations for use of the RAS
              Website owned and operated by Handicapper.net, Inc. ("Right Angle Sports", "RAS",
              "we", "us" or "our") located at raspicks.com. By accessing the website, we assume you
              accept these terms and conditions. Do not continue to use this Website if you do not
              agree to take all of the terms and conditions stated on this page. "Subscriber",
              "Client", "You" and "Your" refers to you, the person log on this website and compliant
              to the Company’s terms and conditions.
            </p>
            <h2>Use of service</h2>
            <p>
              Subscribers must follow all rules to maintain their subscription with RAS. Subscribers
              found or suspected to be in violation of the rules will forfeit access to any current
              or future subscriptions.
            </p>
            <p>You must not:</p>
            <ul>
              <li>Bet any RAS releases early or before receiving a "GO" message.</li>
              <li>
                Be responsible for line changes, limit changes or games going off the board at any
                sportsbook.
              </li>
              <li>Share access or any information from the RAS Website</li>
            </ul>
            <h2>Return policy</h2>
            <p>
              Any unused portion of a RAS service may be refunded at any time for a prorated refund.
              Portions of a service already delivered are not eligible for a refund. Free plays or
              services are not eligible for a refund.
            </p>
            <h2>Cookies</h2>
            <p>
              We employe the use of cookies. By accessing RAS, you agreed to cookies in agreement
              with RAS's <a href="/privacy">Privacy Policy</a>.
            </p>
            <h2>SMS</h2>
            <p>
              RAS will send one-way alerts prompting users to log in to service at appropriate times
              to users who opt in. Message frequency varies. RAS may also send promotional messages
              to users who opt in. Message frequency varies. You can cancel the SMS service at any
              time. Just text "STOP" to the short code. After you send the SMS message "STOP" to us,
              we will send you an SMS message to confirm that you have been unsubscribed. After
              this, you will no longer receive SMS messages from us. If you want to join again, just
              sign up as you did the first time and we will start sending SMS messages to you again.
              If you are experiencing issues with the messaging program you can reply with the
              keyword HELP for more assistance, or you can get help directly at admin@raspicks.com.
              Carriers are not liable for delayed or undelivered messages As always, message and
              data rates may apply for any messages sent to you from us and to us from you. You will
              receive one alert before every release for which you are subscribed. You may also
              receive optional promotional messages on occasion if you have opted in. If you have
              any questions about your text plan or data plan, it is best to contact your wireless
              provider.
            </p>
            <h2>License</h2>
            <p>
              Unless otherwise stated, RAS and/or its licensors own the intellectual property rights
              for all material on RAS. All intellectual property rights are reserved. You may access
              this from RAS for your own personal use subjected to restrictions set in these terms
              and conditions.
            </p>
            <p>You must not:</p>
            <ul>
              <li>Republish material from RAS</li>
              <li>Sell, rent or sub-license material from RAS</li>
              <li>Reproduce, duplicate or copy material from RAS</li>
              <li>Redistribute content from RAS</li>
            </ul>
            <h2>Hyperlinking to our content</h2>
            <p>
              The following organizations may link to our Website without prior written approval:
            </p>
            <ul>
              <li>Government agencies;</li>
              <li>Search engines;</li>
              <li>Government agencies;</li>
              <li>News organizations;</li>
              <li>
                Online directory distributors may link to our Website in the same manner as they
                hyperlink to the Websites of other listed businesses; and
              </li>
              <li>
                System wide Accredited Businesses except soliciting non-profit organizations,
                charity shopping malls, and charity fundraising groups which may not hyperlink to
                our Web site.
              </li>
            </ul>
            <p>
              These organizations may link to our home page, to publications or to other Website
              information so long as the link: (a) is not in any way deceptive; (b) does not falsely
              imply sponsorship, endorsement or approval of the linking party and its products
              and/or services; and (c) fits within the context of the linking party’s site.
            </p>
            <p>
              We may consider and approve other link requests from the following types of
              organizations:
            </p>
            <ul>
              <li>commonly-known consumer and/or business information sources;</li>
              <li>dot.com community sites;</li>
              <li>associations or other groups representing charities;;</li>
              <li>online directory distributors;</li>
              <li>internet portals;</li>
              <li>accounting, law and consulting firms; and</li>
              <li>educational institutions and trade associations.</li>
            </ul>
            <p>
              We will approve link requests from these organizations if we decide that: (a) the link
              would not make us look unfavorably to ourselves or to our accredited businesses; (b)
              the organization does not have any negative records with us; (c) the benefit to us
              from the visibility of the hyperlink compensates the absence of RAS; and (d) the link
              is in the context of general resource information.
            </p>
            <p>
              These organizations may link to our home page so long as the link: (a) is not in any
              way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the
              linking party and its products or services; and (c) fits within the context of the
              linking party’s site.
            </p>
            <p>
              If you are one of the organizations listed in paragraph 2 above and are interested in
              linking to our website, you must inform us by sending an e-mail to RAS. Please include
              your name, your organization name, contact information as well as the URL of your
              site, a list of any URLs from which you intend to link to our Website, and a list of
              the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.
            </p>
            <p>Approved organizations may hyperlink to our Website as follows:</p>
            <ul>
              <li>By use of our corporate name; or</li>
              <li>By use of the uniform resource locator being linked to; or</li>
              <li>
                By use of any other description of our Website being linked to that makes sense
                within the context and format of content on the linking party’s site.
              </li>
            </ul>
            <h2>iFrames</h2>
            <p>
              Without prior approval and written permission, you may not create frames around our
              Webpages that alter in any way the visual presentation or appearance of our Website.
            </p>
            <h2>iFrames</h2>
            <p>
              Without prior approval and written permission, you may not create frames around our
              Webpages that alter in any way the visual presentation or appearance of our Website.
            </p>
            <h2>Content liability</h2>
            <p>
              We shall not be hold responsible for any content that appears on your Website. You
              agree to protect and defend us against all claims that is rising on your Website. No
              link(s) should appear on any Website that may be interpreted as libelous, obscene or
              criminal, or which infringes, otherwise violates, or advocates the infringement or
              other violation of, any third party rights.
            </p>
            <h2>Your privacy</h2>
            <p>
              Please read <a href="/privacy">Privacy Policy</a>.
            </p>
            <h2>Reservation of rights</h2>
            <p>
              We reserve the right to request that you remove all links or any particular link to
              our Website. You approve to immediately remove all links to our Website upon request.
              We also reserve the right to amen these terms and conditions and it’s linking policy
              at any time. By continuously linking to our Website, you agree to be bound to and
              follow these linking terms and conditions.
            </p>
            <h2>Removal of links from our website</h2>
            <p>
              If you find any link on our Website that is offensive for any reason, you are free to
              contact and inform us any moment. We will consider requests to remove links but we are
              not obligated to or so or to respond to you directly. We do not ensure that the
              information on this website is correct, we do not warrant its completeness or
              accuracy; nor do we promise to ensure that the website remains available or that the
              material on the website is kept up to date.
            </p>
            <h2>Privacy of children</h2>
            <p>
              We do not knowingly collect any Personal Information from children under the age of
              13. If you are under the age of 13, please do not submit any Personal Information
              through our Website. We encourage parents and legal guardians to monitor their
              children's Internet usage and to help enforce this Policy by instructing their
              children never to provide Personal Information through our Website without their
              permission. If you have reason to believe that a child under the age of 13 has
              provided Personal Information to us through our Website, please contact us.
            </p>
            <h2>Disclaimer</h2>
            <p>
              To the maximum extent permitted by applicable law, we exclude all representations,
              warranties and conditions relating to our website and the use of this website. Nothing
              in this disclaimer will:
            </p>
            <ul>
              <li>limit or exclude our or your liability for death or personal injury;</li>
              <li>
                limit or exclude our or your liability for fraud or fraudulent misrepresentation;
              </li>
              <li>
                limit any of our or your liabilities in any way that is not permitted under
                applicable law; or
              </li>
              <li>
                exclude any of our or your liabilities that may not be excluded under applicable
                law.
              </li>
            </ul>
            <p>
              The limitations and prohibitions of liability set in this Section and elsewhere in
              this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all
              liabilities arising under the disclaimer, including liabilities arising in contract,
              in tort and for breach of statutory duty.
            </p>
            <p>
              As long as the website and the information and services on the website are provided
              free of charge, we will not be liable for any loss or damage of any nature.
            </p>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

// Main component
function TermsPage() {
  return <Terms />;
}
